import none from "./none";

export default function(series) {
  return none(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-shape/src/order/reverse.js
// module id = ../../../../d3-shape/src/order/reverse.js
// module chunks = 4